var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencilSmallStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 40,
  height: 40,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#1d1d1b",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.2 7.6 8.8 21l-1.5 3.7 3.7-1.5L24.4 9.8c.4-.4.4-1 0-1.4l-.8-.8c-.4-.4-1.1-.4-1.4 0zM11 23.2 8.8 21"
}))));
export default SvgPencilSmallStroke;